export default __webpack_public_path__ + "static/media/carousel2.896cdcc2.jpg";